import React from 'react'
import PropTypes from 'prop-types'
import * as Component from './Overlay.styles'

export const Overlay = ({ children, open, onOverlayClicked }) =>
  open ? (
    <Component.Overlay onClick={ onOverlayClicked }>{children}</Component.Overlay>
  ) : (
    children
  )

Overlay.propTypes = {
  onOverlayClicked: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
}
